import { apiFetch } from '../api';

export const getClientList = (payload) => {
  return apiFetch(`/Client/Search`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const getClientById = (clientGUID) => {
  return apiFetch(`/Client/GetById?clientGUID=${clientGUID}`);
};

export const addClient = (data) => {
  return apiFetch(`/Client/Write`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

export const deleteClientAPI = (clientGUID) => {
  return apiFetch(`/Client/Delete?clientGUID=${clientGUID}`, {
    method: 'POST'
  });
};
